import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height }: SvgIconProps) => {
  const isImage = src.indexOf('.png')>=0
  return (
  <img src={isImage ?  `/img/icons/${src}` : `/img/svg/${src}`} alt={src} width={width} height={height} />
)
};
